export const ORDER_STATUS = {
  PAYMENT_PENDING: 'payment_pending',
  NEW: 'new',
  PREPARING: 'preparing',
  READY_FOR_PICKUP: 'ready_for_pickup',
  COURIER_ASSIGNED: 'courier_assigned',
  PICKED_UP: 'picked_up',
  ON_THE_WAY: 'on_the_way',
  DELIVERED: 'delivered',
  CANCELLED: 'cancelled',
}

export const TERMINAL_ORDER_STATUSES = [ORDER_STATUS.DELIVERED, ORDER_STATUS.CANCELLED]

export const ORDER_STATUS_I18N = {
  unknown: 'order.status.unknown',
  courier: {
    awaitingCourierConfirmation: 'order.status.courier.awaitingCourierConfirmation',
    awaitingRestaurant: 'order.status.courier.awaitingRestaurant',
    readyForPickup: 'order.status.courier.readyForPickup',
    deliverToClient: 'order.status.courier.deliverToClient',
    completed: 'order.status.courier.completed',
    cancelled: 'order.status.courier.cancelled',
  },
  restaurant: {
    awaitingPayment: 'order.status.restaurant.awaitingPayment',
    awaitingRestaurantConfirmation: 'order.status.restaurant.awaitingRestaurantConfirmation',
    preparing: 'order.status.restaurant.preparing',
    readyForPickup: 'order.status.restaurant.readyForPickup',
    handToCourier: 'order.status.restaurant.listHandToCourier',
    awaitingCourier: 'order.status.restaurant.listAwaitingCourier',
    withCourier: 'order.status.restaurant.listWithCourier',
    delivering: 'order.status.restaurant.listDelivering',
    completed: 'order.status.restaurant.completed',
    cancelled: 'order.status.restaurant.cancelled',
  },
  client: {
    paymentPending: 'order.clientCard.status.paymentPending',
    new: 'order.clientCard.status.new',
    preparing: 'order.clientCard.status.preparing',
    readyForPickup: 'order.clientCard.status.readyForPickup',
    courierAssigned: 'order.clientCard.status.courierAssigned',
    pickedUp: 'order.clientCard.status.pickedUp',
    delivered: 'order.clientCard.status.delivered',
    cancelled: 'order.clientCard.status.cancelled',
  },
}

const COURIER_STATUS_I18N_BY_ORDER_STATUS = {
  [ORDER_STATUS.NEW]: ORDER_STATUS_I18N.courier.awaitingCourierConfirmation,
  [ORDER_STATUS.COURIER_ASSIGNED]: ORDER_STATUS_I18N.courier.awaitingCourierConfirmation,
  [ORDER_STATUS.PREPARING]: ORDER_STATUS_I18N.courier.awaitingRestaurant,
  [ORDER_STATUS.READY_FOR_PICKUP]: ORDER_STATUS_I18N.courier.readyForPickup,
  [ORDER_STATUS.PICKED_UP]: ORDER_STATUS_I18N.courier.deliverToClient,
  [ORDER_STATUS.ON_THE_WAY]: ORDER_STATUS_I18N.courier.deliverToClient,
  [ORDER_STATUS.DELIVERED]: ORDER_STATUS_I18N.courier.completed,
  [ORDER_STATUS.CANCELLED]: ORDER_STATUS_I18N.courier.cancelled,
}

const RESTAURANT_STATUS_I18N_BY_ORDER_STATUS = {
  [ORDER_STATUS.PAYMENT_PENDING]: ORDER_STATUS_I18N.restaurant.awaitingPayment,
  [ORDER_STATUS.NEW]: ORDER_STATUS_I18N.restaurant.awaitingRestaurantConfirmation,
  [ORDER_STATUS.PREPARING]: ORDER_STATUS_I18N.restaurant.preparing,
  [ORDER_STATUS.READY_FOR_PICKUP]: ORDER_STATUS_I18N.restaurant.handToCourier,
  [ORDER_STATUS.COURIER_ASSIGNED]: ORDER_STATUS_I18N.restaurant.awaitingCourier,
  [ORDER_STATUS.PICKED_UP]: ORDER_STATUS_I18N.restaurant.withCourier,
  [ORDER_STATUS.ON_THE_WAY]: ORDER_STATUS_I18N.restaurant.delivering,
  [ORDER_STATUS.DELIVERED]: ORDER_STATUS_I18N.restaurant.completed,
  [ORDER_STATUS.CANCELLED]: ORDER_STATUS_I18N.restaurant.cancelled,
}

export function isTerminalOrderStatus(status) {
  return TERMINAL_ORDER_STATUSES.includes(status)
}

export function getCourierOrderStatusI18nKey(
  status,
  { acceptedAt = null, pickedUpAt = null, deliveredAt = null } = {},
) {
  if (deliveredAt || status === ORDER_STATUS.DELIVERED) {
    return ORDER_STATUS_I18N.courier.completed
  }
  if (status === ORDER_STATUS.CANCELLED) {
    return ORDER_STATUS_I18N.courier.cancelled
  }
  if (status === ORDER_STATUS.PICKED_UP || pickedUpAt) {
    return ORDER_STATUS_I18N.courier.deliverToClient
  }
  if (!acceptedAt && status && !isTerminalOrderStatus(status)) {
    return ORDER_STATUS_I18N.courier.awaitingCourierConfirmation
  }
  if (acceptedAt && status === ORDER_STATUS.READY_FOR_PICKUP) {
    return ORDER_STATUS_I18N.courier.readyForPickup
  }
  if (
    acceptedAt &&
    [ORDER_STATUS.COURIER_ASSIGNED, ORDER_STATUS.PREPARING].includes(status)
  ) {
    return ORDER_STATUS_I18N.courier.awaitingRestaurant
  }
  return COURIER_STATUS_I18N_BY_ORDER_STATUS[status] ?? ORDER_STATUS_I18N.unknown
}

export function getRestaurantOrderStatusI18nKey(status) {
  return RESTAURANT_STATUS_I18N_BY_ORDER_STATUS[status] ?? ORDER_STATUS_I18N.unknown
}

const CLIENT_STATUS_I18N_BY_ORDER_STATUS = {
  [ORDER_STATUS.PAYMENT_PENDING]: ORDER_STATUS_I18N.client.paymentPending,
  [ORDER_STATUS.NEW]: ORDER_STATUS_I18N.client.new,
  [ORDER_STATUS.PREPARING]: ORDER_STATUS_I18N.client.preparing,
  [ORDER_STATUS.READY_FOR_PICKUP]: ORDER_STATUS_I18N.client.readyForPickup,
  [ORDER_STATUS.COURIER_ASSIGNED]: ORDER_STATUS_I18N.client.courierAssigned,
  [ORDER_STATUS.PICKED_UP]: ORDER_STATUS_I18N.client.pickedUp,
  [ORDER_STATUS.ON_THE_WAY]: ORDER_STATUS_I18N.client.pickedUp,
  [ORDER_STATUS.DELIVERED]: ORDER_STATUS_I18N.client.delivered,
  [ORDER_STATUS.CANCELLED]: ORDER_STATUS_I18N.client.cancelled,
}

export function getClientOrderStatusI18nKey(status) {
  return CLIENT_STATUS_I18N_BY_ORDER_STATUS[status] ?? ORDER_STATUS_I18N.unknown
}
